import Req from '../../$axios';

const serviceModule = {
  // 编辑用户信息
  editinfo(params) {
    return Req({
      url: 'user/updateinfo/',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 上传用户头像
  uploadAvatar(params) {
    return Req({
      url: 'attachments/upload/',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true,
      isUpload: true
    }, params);
  },
  // 更新用户信息
  updateSelfInfo(params) {
    return Req({
      url: 'users/updateSelfInfo',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true
    }, params);
  },
  // 更新用户信息(头像)
  updateSelfInfoToAvatar(params) {
    return Req({
      url: 'users/updateSelfInfoToAvatar',
      method: 'post',
      isJSON: false,
      tip: false,
      isAlertErr: true
    }, params);
  },
};

export default {
  ...serviceModule
};
